import p1_img from "./product_1.png";
import p2_img from "./product_2.png";
import p3_img from "./product_3.png";
import p4_img from "./product_4.png";

let data_product = [
  {
    id: 1,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
  },
  { id: 2, name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse", image: p2_img, new_price: 85.0, old_price: 120.5 },
  { id: 3, name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse", image: p3_img, new_price: 60.0, old_price: 100.5 },
  { id: 4, name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse", image: p4_img, new_price: 100.0, old_price: 150.0 },
];

export default data_product;
